import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SpinnerService } from '../../../services/spinner.service';
import { BookingService } from '../../../services/booking.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  chaufferBookingStatusNum,
  liveTrackingStatus,
  stageOneStatus,
  stageTwoDetailsStatus,
  values,
  nonTrackingDriverInfoStatus,
  PANEL_SERVICE_TYPE,
  rhLiveTrackingStatus,
  rhNonTrackingDriverInfoStatus,
  RhRideStatus,
  rhRideStatusLabel,
} from '../../core/constants/keys.constant';
import { SocketService } from '../../../services/socket.service';
import { UserTrackingLogicService } from '../../../services/user-tracking-logic.service';
import { Booking } from '../../models/booking.model';
import { Subject, takeUntil } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { staticText } from '../../core/constants/staticText.const';
import _ from 'underscore';
import { InitialService } from '../../../services/initial.service';
import { CommonModule } from '@angular/common';
import { NoDataFoundComponent } from '../../shared/components/no-data-found/no-data-found.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../services/toaster.service';
import { assets } from '../../core/constants/assets.const';
import { MatTooltipModule } from '@angular/material/tooltip';
declare const google: any;

// Mobile bottom-sheet tuning.
const MOBILE_BREAKPOINT = 767.98;
// Movement (px) before a pointer gesture counts as a drag rather than a tap.
const DRAG_START_THRESHOLD = 6;
// px/ms past which a flick decides the snap direction regardless of position.
const FLICK_VELOCITY = 0.45;
// Fallback peek height when the drop-off row hasn't rendered yet.
const DEFAULT_SHEET_PEEK = 220;
// Legacy fallback grace window (seconds).
const DEFAULT_WAITING_GRACE_SECONDS = 300;

type TimerPhase = 'pickup-grace' | 'pickup-waiting' | 'dropoff-grace' | 'dropoff-waiting' | 'completed-wait';
type StoredAnchorPhase = 'arrived' | 'waiting' | 'dropoff-arrived';

@Component({
  selector: 'rental-user-tracking',
  standalone: true,
  imports: [
    CommonModule,
    NoDataFoundComponent,
    TranslateModule,
    MatTooltipModule,
  ],
  templateUrl: './user-tracking.component.html',
  styleUrl: './user-tracking.component.scss',
})
export class UserTrackingComponent implements AfterViewInit, OnDestroy, OnInit {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  protected bookingId: string | null = null;
  protected previousPage: string | number | null = 1;
  protected selectedParentIndex: string | number | null = 0;
  protected selectedChildIndex: string | number | null = 0;
  protected bookingDetail: Booking | undefined | null = undefined;
  protected staticText = staticText;
  protected addressFormGroup!: FormGroup;
  protected assests = assets;

  protected locations: any[] = [
    {
      lat: '',
      lng: '',
      type: 'pickup',
    },
    {
      lat: '',
      lng: '',
      type: 'dropOf',
    },
  ];
  protected markers: any[] = [];
  protected polyline: any;
  protected directionsService: any;
  protected directionsRenderer: any;
  protected lat: number = 30.7227017;
  protected lng: number = 76.7001335;
  protected stageOneStatus: any[] = stageOneStatus;
  protected stageTwoStatus: any[] = stageTwoDetailsStatus;
  protected nonTrackingDriverInfoStatus: any[] = nonTrackingDriverInfoStatus;
  protected liveTrackingStatus: any[] = liveTrackingStatus;
  private trackingStage: number = 1;
  private vendorMarker!: google.maps.Marker;
  private dropOffMarker!: google.maps.Marker;
  private pickupMarker!: google.maps.Marker;
  protected driverMarker!: google.maps.Marker;
  private map!: google.maps.Map;
  protected chaufferBookingStatusNum: any[] = chaufferBookingStatusNum;
  protected polyLines: any[] = [];
  protected userPickDropPolyline!: google.maps.Polyline;
  protected stageOnePolyMarkers: any[] = [];
  protected stageTwoPolyMarkers: any[] = [];
  protected stageOneTrackingPolyline: any[] = [];
  protected stageTwoTrackingPolyline: any[] = [];
  protected stageOneBookingTracking: any[] = [];
  protected stageTwoBookingTracking: any[] = [];
  protected allBookingStatuses: any = values;
  // protected platformServiceType: number | null = null;
  // protected PANEL_SERVICE_TYPE = PANEL_SERVICE_TYPE;

  // Ride Hailing (RIDE_HAILING) equivalents.
  protected RhRideStatus = RhRideStatus;
  protected rhRideStatusLabel = rhRideStatusLabel;
  protected rhLiveTrackingStatus: number[] = rhLiveTrackingStatus;
  protected rhNonTrackingDriverInfoStatus: number[] = rhNonTrackingDriverInfoStatus;
  protected trackingEtaText = '';

  protected timerText = '';
  protected timerMode: TimerPhase | null = null;

  private timerIntervalId: any = null;
  // Pickup-leg anchors.
  private arrivalAnchorMs: number | null = null;
  private waitingAnchorMs: number | null = null;
  // Drop-off-leg anchors.
  private dropOffArrivalAnchorMs: number | null = null;
  private dropOffWaitingAnchorMs: number | null = null;
  private dropOffWaitingEnded = false;

  // --- mobile bottom sheet ---
  @ViewChild('sheet') private sheetRef?: ElementRef<HTMLElement>;
  @ViewChild('panelBody') private panelBodyRef?: ElementRef<HTMLElement>;

  protected sheetExpanded = false;
  protected isSheetDragging = false;
  private isMobileViewport = false;
  private sheetHeight = 0;
  private sheetPeek = DEFAULT_SHEET_PEEK;
  private sheetDragTranslate: number | null = null;
  private sheetResizeObserver?: ResizeObserver;
  private locationListenerBound = false;

  private joinRoomListenerBound = false;
  private driverAssignedListenerBound = false;

  private dragPointerId: number | null = null;
  private dragStartY = 0;
  private dragStartTranslate = 0;
  private dragLastY = 0;
  private dragLastTime = 0;
  private dragVelocity = 0;

  private dragArmedFromBody = false;

  // The drop-off row marks the bottom of the collapsed "peek" — everything above it (grabber, status, pickup) stays visible while the sheet is down.
  @ViewChild('peekAnchor') private set peekAnchor(
    ref: ElementRef<HTMLElement> | undefined,
  ) {
    this.peekAnchorRef = ref;
    if (ref) setTimeout(() => this.measureSheet());
  }
  private peekAnchorRef?: ElementRef<HTMLElement>;

  constructor(
    protected _zone: NgZone,
    private _spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private _bookingService: BookingService,
    private _socketService: SocketService,
    private _initialService: InitialService,
    private router: Router,
    private route: ActivatedRoute,
    private _toasterService: ToasterService,
    private _translateService: TranslateService,
    private _trackingLogicService: UserTrackingLogicService,
  ) {}

  /** Resolves to the rental or ride-hailing "live tracking" status */
  protected get activeLiveTrackingStatus(): number[] {
  return this.rhLiveTrackingStatus;
  }

  /** Resolves to the rental or ride-hailing "driver info" status. */
  protected get activeNonTrackingDriverInfoStatus(): number[] {
  return this.rhNonTrackingDriverInfoStatus;
  }

  /**
   * True while the booking is in a state where the route + chauffeur details are
   * still meaningful. When false the panel falls back to the "trip ended" message.
   */
  protected get isTripActive(): boolean {
  const booking = this.bookingDetail;
  if (!booking) return false;
  if (booking.orderStatus === RhRideStatus.RIDE_COMPLETED) return false;
  return (
    this.activeNonTrackingDriverInfoStatus.includes(booking.orderStatus) ||
    this.activeLiveTrackingStatus.includes(booking.orderStatus)
  );
}


  protected get pickupAddress(): string {
    return this.bookingDetail?.pickup?.address || '-';
  }

  protected get dropOffAddress(): string {
    return this.bookingDetail?.dropOf?.address || '-';
  }

  /** Vehicle "Brand Model" — from whichever name fields the booking carries. */
  protected get vehicleName(): string {
    const booking = this.bookingDetail as any;
    if (!booking) return '';
    const brand = booking.brandId?.name || booking.carId?.brand?.name || '';
    const model = booking.carName || booking.carId?.carName || '';
    return [brand, model].filter(Boolean).join(' ');
  }

  /** Registration / plate number — ride-hailing carries its own field, rental uses carNo. */
  protected get vehicleId(): string {
  const booking = this.bookingDetail as any;
  if (!booking) return '';
  return booking.rhCarDetails?.carRegistrationNo || booking.carNo || booking.carId?.carNo || '';
}



  /** "Plate no. • Brand Model" — matches the order used by the user app. */
  protected get vehicleLabel(): string {
    return [this.vehicleId, this.vehicleName].filter(Boolean).join(' • ');
  }

  /** Expected drop-off time, ride-hailing first then the rental booking end time. */
  protected get dropOffTime(): string | null {
    const booking = this.bookingDetail as any;
    if (!booking) return null;
    return booking.dropOffTime || booking.endTime || null;
  }

  private isArrivedAtPickupStatus(status: number | null | undefined): boolean {
  return status != null && status === RhRideStatus.ARRIVED_AT_PICKUP;
}

  private isWaitingStatus(status: number | null | undefined): boolean {
  return status != null && status === RhRideStatus.WAITING;
}

  private isArrivedAtDropOffStatus(status: number | null | undefined): boolean {
  return status != null && status === RhRideStatus.ARRIVED_AT_DROPOFF;
}

  /** Free-wait seconds for the pickup leg, from areaCategoryFares (hot-zone vs standard). Falls back to the legacy static grace for older bookings without fare config. */
  private getPickupFreeSeconds(): number {
    const bd = this.bookingDetail as any;
    const fares = bd?.areaCategoryFares;
    if (!fares) return DEFAULT_WAITING_GRACE_SECONDS;

    const minutes = bd?.isPickUpInHotZone ? fares.hotZonePickupWaitingFreeTime : fares.waitingTimeFree;
    return Number.isFinite(Number(minutes)) ? Number(minutes) * 60 : DEFAULT_WAITING_GRACE_SECONDS;
  }

  private getDropOffFreeSeconds(): number | null {
    const bd = this.bookingDetail as any;
    if (!bd?.isDropOffInHotZone) return null;

    const fares = bd?.areaCategoryFares;
    if (!fares) return null;

    const minutes = fares.hotZoneDropOffWaitingFreeTime;
    return Number.isFinite(Number(minutes)) ? Number(minutes) * 60 : null;
  }

  private syncArrivalTimer(): void {
    if (!this.bookingId) return;
    const status = this.bookingDetail?.orderStatus;
    const bd = this.bookingDetail as any;
    const storageKey = `esqyre_arrival_timer_${this.bookingId}`;
    const dropOffApplicable = !!bd?.isDropOffInHotZone;
    this.dropOffWaitingEnded = this.hasDropOffWaitingEnded(bd);

    if (this.dropOffWaitingEnded) {
      this.stopTimerLoop();
      this.dropOffArrivalAnchorMs = null;
      this.dropOffWaitingAnchorMs = null;
      this.timerText = '';
      this.timerMode = null;
      localStorage.removeItem(storageKey);
      return;
    }

    if (this.isArrivedAtPickupStatus(status)) {
      const stored = this.readTimerAnchor(storageKey);
      this.arrivalAnchorMs = stored?.phase === 'arrived' ? stored.anchor : this.parseTimestamp(bd?.arrivedAt) ?? Date.now();
      if (!stored || stored.phase !== 'arrived') {
        this.writeTimerAnchor(storageKey, {
          phase: 'arrived',
          anchor: this.arrivalAnchorMs,
        });
      }
      this.waitingAnchorMs = null;
      this.dropOffArrivalAnchorMs = null;
      this.dropOffWaitingAnchorMs = null;
      return;
    }

    if (this.isWaitingStatus(status)) {
      const stored = this.readTimerAnchor(storageKey);

      this.waitingAnchorMs = this.parseTimestamp(bd?.waitingStart) ?? (stored?.phase === 'waiting' ? stored.anchor : null) ?? Date.now();

      if (!stored || stored.phase !== 'waiting') {
        this.writeTimerAnchor(storageKey, {
          phase: 'waiting',
          anchor: this.waitingAnchorMs,
        });
      }
      this.arrivalAnchorMs = null;
      this.dropOffArrivalAnchorMs = null;
      this.dropOffWaitingAnchorMs = null;
      return;
    }

    if (dropOffApplicable && this.isArrivedAtDropOffStatus(status)) {
      const dropOffDriverWaitingAt = this.parseTimestamp(bd?.dropOffDriverWaitingAt);
      const stored = this.readTimerAnchor(storageKey);
      this.dropOffArrivalAnchorMs = dropOffDriverWaitingAt ?? (stored?.phase === 'dropoff-arrived' ? stored.anchor : null) ?? Date.now();

      if (dropOffDriverWaitingAt !== null || !stored || stored.phase !== 'dropoff-arrived') {
        this.writeTimerAnchor(storageKey, {
          phase: 'dropoff-arrived',
          anchor: this.dropOffArrivalAnchorMs,
        });
      }
      this.dropOffWaitingAnchorMs = null;
      this.arrivalAnchorMs = null;
      this.waitingAnchorMs = null;
      return;
    }

    // Booking moved beyond waiting-related statuses
    this.stopTimerLoop();
    this.arrivalAnchorMs = null;
    this.waitingAnchorMs = null;
    this.dropOffArrivalAnchorMs = null;
    this.dropOffWaitingAnchorMs = null;
    this.timerMode = null;
    localStorage.removeItem(storageKey);
  }

  private hasDropOffWaitingEnded(booking: any): boolean {
    const value = booking?.dropOffWaitingEnd;
    return value !== undefined && value !== null && value !== '' && value !== false && value !== 0 && value !== '0';
  }

  private readTimerAnchor(key: string): { phase: StoredAnchorPhase; anchor: number } | null {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  private writeTimerAnchor(
    key: string,
    value: { phase: StoredAnchorPhase; anchor: number },
  ): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* ignore storage failures */
    }
  }

  private parseTimestamp(value: any): number | null {
    if (!value) return null;
    const timestamp = new Date(value).getTime();
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  private stopTimerLoop(): void {
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId);
      this.timerIntervalId = null;
    }
  }

  private formatClock(totalSeconds: number): string {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  protected get etaLabel(): string | null {
    const booking = this.bookingDetail as any;
    const durationSeconds = booking?.last_duration?.durationSeconds;

    if (booking?.isScheduled && booking?.orderStatus === RhRideStatus.DRIVER_ASSIGNED) {
      const scheduledTime = booking?.startTime ?? null;
      return scheduledTime ? this.formatScheduledArrival(scheduledTime) : null;
    }

    if (durationSeconds === null || durationSeconds === undefined || durationSeconds === 0) return null;
    return this.formatEta(Number(durationSeconds));
  }

  private formatScheduledArrival(value: string): string {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    const time = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);
    return `Arriving at pickup by ${time}`;
  }

  private formatEta(durationSeconds?: number): string {
    if (!durationSeconds || durationSeconds <= 0) return '0 mins';
    const totalMinutes = Math.ceil(durationSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0) {
      if (minutes > 0) {
        return `${hours} ${hours === 1 ? 'hr' : 'hrs'} ${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
      }
      return `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
    }
    return `${totalMinutes} ${totalMinutes === 1 ? 'min' : 'mins'}`;
  }

  protected get driverPhoneHref(): string {
    const driver = this.bookingDetail?.driverId;
    if (!driver?.phoneNo) return '';
    return `tel:${driver.dialCode ? driver.dialCode : ''}${driver.phoneNo}`;
  }

  // Inline transform for the sheet; `null` on desktop so the sidebar keeps its static position. */
  protected get sheetTransform(): string | null {
    if (!this.isMobileViewport) return null;
    const translate = this.sheetDragTranslate ?? (this.sheetExpanded ? 0 : this.collapsedTranslate);
    return `translateY(${translate}px)`;
  }

  // How far down the sheet sits when collapsed. 0 means the content fits — nothing to drag.
  private get collapsedTranslate(): number {
    return Math.max(0, this.sheetHeight - this.sheetPeek);
  }

  ngAfterViewInit(): void {
    this.measureSheet();
    this.observeSheetResize();
  }

  @HostListener('window:resize')
  protected onWindowResize(): void {
    this.measureSheet();
    if (this.map) {
      google.maps.event.trigger(this.map, 'resize');
    }
  }

  // Re-reads the sheet height and the peek offset; content and viewport both move them.
  private measureSheet(): void {
    this.isMobileViewport = window.innerWidth <= MOBILE_BREAKPOINT;

    const sheet = this.sheetRef?.nativeElement;
    if (!sheet) return;

    this.sheetHeight = sheet.offsetHeight;

    const anchor = this.peekAnchorRef?.nativeElement;
    if (anchor) {
      // Both rects carry the same transform, so their delta is the untransformed offset.
      const peek = anchor.getBoundingClientRect().top - sheet.getBoundingClientRect().top;
      this.sheetPeek = Math.max(120, Math.round(peek) + 8);
    } else {
      this.sheetPeek = DEFAULT_SHEET_PEEK;
    }

    if (!this.isMobileViewport) {
      this.sheetExpanded = false;
      this.sheetDragTranslate = null;
    }
  }

  private getRideHailingStatusLabel(status: number): string {
    switch (status) {
      case RhRideStatus.DRIVER_ASSIGNED:
        return 'Chauffeur Assigned';

      case RhRideStatus.START_RIDE:
        return 'Chauffeur on the way';

      case RhRideStatus.NEAR_BY_PICKUP:
        return 'Chauffeur is arriving now';

      case RhRideStatus.ARRIVED_AT_PICKUP:
      case RhRideStatus.WAITING:
        return 'Chauffeur Arrived at pickup';

      case RhRideStatus.RIDE_STARTED:
        return 'In Progress';

      case RhRideStatus.NEAR_BY_ARRIVING:
        return 'Arriving at Drop-off';

      case RhRideStatus.ARRIVED_AT_DROPOFF:
        return 'Arrived at Drop-off';

      default:
         return this._translateService.instant(this.getBookingStatusByKey(status));
    }
  }

  protected get trackingStatusLabel(): string {
  if (!this.isTripActive) return '';
  const status = this.bookingDetail?.orderStatus;
  if (status == null) return '';
  return this.getRideHailingStatusLabel(status);
}

protected get trackingStatusSubtext(): string {
  if (!this.isTripActive) return '';
  const status = this.bookingDetail?.orderStatus;
  if (status == null) return '';
  return this.getRideHailingStatusSubtext(status);
}

  private getRideHailingStatusSubtext(status: number): string {
    const bd = this.bookingDetail as any;
    // Scheduled bookings drop the "to pickup " prefix and just show "• Ride starts soon".
    const isScheduledAssigned = !!bd?.isScheduled && status === RhRideStatus.DRIVER_ASSIGNED;

    switch (status) {
      case RhRideStatus.DRIVER_ASSIGNED:
        return `${isScheduledAssigned ? '' : 'to pickup '}• Ride starts soon`;

      case RhRideStatus.START_RIDE:
        return this.trackingEtaText ? 'to pickup' : '';

      case RhRideStatus.NEAR_BY_PICKUP:
        return '';

      case RhRideStatus.ARRIVED_AT_PICKUP:
      case RhRideStatus.WAITING:
        return 'Waiting at pickup';

      case RhRideStatus.RIDE_STARTED:
        return 'to destination';

      case RhRideStatus.NEAR_BY_ARRIVING:
        return '';

      case RhRideStatus.ARRIVED_AT_DROPOFF:
        return bd?.dropOffWaitingEnd ? '' : 'Waiting for ride completion';

      default:
        return '';
    }
  }

  private updateTrackingEta(): void {
  this.trackingEtaText = '';
  if (!this.isTripActive) return;

  const status = this.bookingDetail?.orderStatus;
  if (status == null) return;

  const isScheduled = !!(this.bookingDetail as any)?.isScheduled;
  this.trackingEtaText = status === RhRideStatus.DRIVER_ASSIGNED && !isScheduled
    ? `~${this.getTrackingEtaValue()}`
    : `${this.getTrackingEtaValue()}`;
}

getBookingStatusByKey(key: number | null | undefined): string {
  return key != null && this.rhRideStatusLabel[key] ? this.rhRideStatusLabel[key] : '';
}

  private getTrackingEtaValue(): string {
    return this.etaLabel ?? '';
  }

  private observeSheetResize(): void {
    const sheet = this.sheetRef?.nativeElement;
    if (!sheet || typeof ResizeObserver === 'undefined') return;

    this.sheetResizeObserver = new ResizeObserver(() => {
      this._zone.run(() => this.measureSheet());
    });
    this.sheetResizeObserver.observe(sheet);
  }

  protected onSheetPointerDown(event: PointerEvent): void {
    if (!this.isMobileViewport || this.collapsedTranslate <= 0) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    // Expanded, the body scrolls natively — only the header strip stays draggable...
    const startedOnHeader = !!(event.target as HTMLElement).closest('.sheet-header');

    if (this.sheetExpanded && !startedOnHeader) {
      const body = this.panelBodyRef?.nativeElement;
      if (!body || body.scrollTop > 0) return;
    }

    this.dragPointerId = event.pointerId;
    this.dragStartY = event.clientY;
    this.dragLastY = event.clientY;
    this.dragLastTime = event.timeStamp;
    this.dragVelocity = 0;
    this.dragStartTranslate = this.sheetExpanded ? 0 : this.collapsedTranslate;
    this.dragArmedFromBody = this.sheetExpanded && !startedOnHeader;
  }

  protected onSheetPointerMove(event: PointerEvent): void {
    if (this.dragPointerId !== event.pointerId) return;

    const delta = event.clientY - this.dragStartY;

    if (!this.isSheetDragging) {
      if (Math.abs(delta) < DRAG_START_THRESHOLD) return;

      if (this.dragArmedFromBody && delta < 0) {
        this.dragPointerId = null;
        this.dragArmedFromBody = false;
        return;
      }

      this.isSheetDragging = true;
      (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    }

    const elapsed = event.timeStamp - this.dragLastTime;
    if (elapsed > 0) this.dragVelocity = (event.clientY - this.dragLastY) / elapsed;
    this.dragLastY = event.clientY;
    this.dragLastTime = event.timeStamp;

    this.sheetDragTranslate = Math.min(this.collapsedTranslate, Math.max(0, this.dragStartTranslate + delta));
    event.preventDefault();
  }

  protected onSheetPointerUp(event: PointerEvent): void {
    if (this.dragPointerId !== event.pointerId) return;

    const host = event.currentTarget as HTMLElement;
    if (host.hasPointerCapture(event.pointerId)) host.releasePointerCapture(event.pointerId);
    this.dragPointerId = null;
    this.dragArmedFromBody = false;

    // A tap on the collapsed sheet pulls it up, same as the apps.
    if (!this.isSheetDragging) {
      this.sheetExpanded = true;
      return;
    }

    const translate = this.sheetDragTranslate ?? this.dragStartTranslate;
    this.isSheetDragging = false;
    this.sheetDragTranslate = null;

    this.sheetExpanded = Math.abs(this.dragVelocity) > FLICK_VELOCITY ? this.dragVelocity < 0 : translate < this.collapsedTranslate / 2;

    // Collapsing hides the scrolled-away content, so rewind to the peek.
    if (!this.sheetExpanded && this.panelBodyRef) this.panelBodyRef.nativeElement.scrollTop = 0;
  }

  ngOnInit(): void {
    this.bookingId = this.route.snapshot.paramMap.get('id');
    // this.platformServiceType = this.resolvePlatformServiceType();

    if (this.bookingId) {
      this._socketService.initSocket(this.bookingId);
      this.handleRealTimeUpdation();
    }
    this.getBookingDetail();
  }

  // private resolvePlatformServiceType(): number {
  //   const storageKey = `esqyre_tracking_platform_${this.bookingId}`;
  //   const fromUrl = this.route.snapshot.queryParamMap.get('platformServiceType');
  //   const urlValue = fromUrl !== null && fromUrl !== '' ? Number(fromUrl) : NaN;

  //   if (Number.isFinite(urlValue)) {
  //     try { localStorage.setItem(storageKey, String(urlValue)); } catch { /* ignore */ }

  //     this.router.navigate([], {
  //       relativeTo: this.route,
  //       queryParams: { platformServiceType: null },
  //       queryParamsHandling: 'merge',
  //       replaceUrl: true,
  //     });
  //     return urlValue;
  //   }

  //   try {
  //     const stored = Number(localStorage.getItem(storageKey));
  //     if (localStorage.getItem(storageKey) !== null && Number.isFinite(stored)) return stored;
  //   } catch { /* ignore */ }

  //   return PANEL_SERVICE_TYPE.SELF_CHAUFFEUR;
  // }

  currentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          if (this.lat && this.lng) {
            this._initialService.load().then(() => {
              this.initMap(this.lat, this.lng);
            });
          }
        }
      });
    }
  }

  initMap(lat: number, lng: number): void {
    const mapElement = document.getElementById('map');
    if (!mapElement) {
      console.error('Map element not found');
      return;
    }
    this.map = new google.maps.Map(mapElement, {
      zoom: 12,
      center: {
        lat,
        lng,
      },
      mapTypeControl: false,
      streetViewControl: false,
      scaleControl: true,
      zoomControl: true,
      indoorLevelPicker: false,
      fullscreenControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 3.5,
      },
      markerOptions: {
        icon: {
          url: '',
          scaledSize: new google.maps.Size(50, 50),
        },
      },
    });
    this.directionsRenderer.setMap(this.map);

    requestAnimationFrame(() => {
      google.maps.event.trigger(this.map, 'resize');
      this.map.setCenter({ lat, lng });
    });
  }

  private getWaitingWindow(): { start: number | null; end: number | null } {
    const booking = this.bookingDetail as any;

    const startRaw = booking?.waitingStart ?? null;

    const endRaw = booking?.waitingEnd ?? null;

    const start = startRaw ? new Date(startRaw).getTime() : NaN;

    const end = endRaw ? new Date(endRaw).getTime() : NaN;

    return {
      start: Number.isFinite(start) ? start : null,
      end: Number.isFinite(end) ? end : null,
    };
  }

  initializeMapAndRoute(): void {
    this._trackingLogicService.initializeMapAndRoute(this);
  }

  getBookingTracking(): void {
    this._trackingLogicService.getBookingTracking(this);
  }

  handleListenerforLatLng(): void {
    if (this.joinRoomListenerBound) return;
    this.joinRoomListenerBound = true;

    this._socketService.onEvent('joinRoomOk').pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this._zone.run(() => {
          console.log('joinRoomOk', res);
          if (res.statusCode === 200 && !this.locationListenerBound) {
            this.locationListenerBound = true;
            this._trackingLogicService.handleRealTimeUpdationForLatAndLng(this);
          }
        });
      },
    });
  }

  private getArrivedAtPickupTime(): number | null {
    const arrivedAt = this.bookingDetail?.arrivedAt;

    if (arrivedAt) {
      const parsed = new Date(arrivedAt).getTime();

      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }

    return this.arrivalAnchorMs;
  }

  private getWaitingStartTime(): number | null {
    const { start } = this.getWaitingWindow();
    if (start !== null) {
      return start;
    }
    return this.waitingAnchorMs;
  }

  handleEmitterForLatLng(): void {
    const payload = { bookingId: this.bookingId };
    this._socketService.emitAction('joinRoom', payload);
  }

  private updateTrackingTimer(): void {
    const status = this.bookingDetail?.orderStatus;
    const bd = this.bookingDetail as any;

    this.timerText = '';
    this.timerMode = null;

    if (status == null || !this.isTripActive) return;

    if (status === RhRideStatus.ARRIVED_AT_PICKUP) {
      const arrivedAt = this.getArrivedAtPickupTime();
      if (arrivedAt === null) return;

      const freeSeconds = this.getPickupFreeSeconds();
      const expiryTime = arrivedAt + freeSeconds * 1000;
      const remainingSeconds = Math.max(0, Math.floor((expiryTime - Date.now()) / 1000));

      this.timerText = this.formatClock(remainingSeconds);
      this.timerMode = 'pickup-grace';
      return;
    }

    if (status === RhRideStatus.WAITING) {
      const start = this.getWaitingStartTime();
      if (start === null) return;

      const elapsedSeconds = Math.max(0, Math.floor((Date.now() - start) / 1000));
      this.timerText = `${this.formatClock(elapsedSeconds)}`;
      this.timerMode = 'pickup-waiting';
      return;
    }

    if (status === RhRideStatus.ARRIVED_AT_DROPOFF && bd?.isDropOffInHotZone && !this.hasDropOffWaitingEnded(bd)) {
      const freeSeconds = this.getDropOffFreeSeconds();
      if (freeSeconds === null) return;

      const driverWaitingAt = this.parseTimestamp(bd?.dropOffDriverWaitingAt) ??
      this.dropOffArrivalAnchorMs;
      if (driverWaitingAt === null) return;
      this.dropOffArrivalAnchorMs = driverWaitingAt;

      const now = Date.now();
      const freeEndTime = driverWaitingAt + freeSeconds * 1000;

      if (now < freeEndTime) {
        const remainingSeconds = Math.max(0, Math.floor((freeEndTime - now) / 1000));

        this.timerText = this.formatClock(remainingSeconds);
        this.timerMode = 'dropoff-grace';
        return;
      }

      const waitingElapsedSeconds = Math.max(0, Math.floor((now - driverWaitingAt) / 1000) - freeSeconds);

      this.dropOffWaitingAnchorMs = freeEndTime;

      this.timerText = `${this.formatClock(waitingElapsedSeconds)}`;
      this.timerMode = 'dropoff-waiting';
    }
  }

  handleRealTimeUpdation(): void {
  this._socketService.onEvent('orderStatusUpdated').pipe(takeUntil(this.destroy$)).subscribe({
    next: (res: any) => {
      this._zone.run(() => {
        const data = res?.data;
        if (!data || !this.bookingDetail || data.bookingID != this.bookingDetail.bookingID) return;

        this.bookingDetail['orderStatus'] = data.orderStatus;
        if (data.dropOffDriverWaitingAt !== undefined) {
          (this.bookingDetail as any).dropOffDriverWaitingAt = data.dropOffDriverWaitingAt;
        }

        this.applyDurationPayload(data);
        this.syncArrivalTimer();
        this.syncTrackingUi();

        if (this.bookingDetail.orderStatus === RhRideStatus.RIDE_COMPLETED) {
          this.stopTimerLoop();
          this.timerText = '';
          this.timerMode = null;
          this._trackingLogicService.clearRideHailingTracking(this);
          this.sheetExpanded = false;
          this.sheetDragTranslate = null;
          this.cdr.detectChanges();
          this.refreshMobileSheetAfterRealtimeUpdate();
          return;
        }

        this._trackingLogicService.refreshRideHailingMarkers(this);

        if (!this.activeLiveTrackingStatus.includes(this.bookingDetail.orderStatus)) {
          this._trackingLogicService.clearRideHailingTracking(this);
        } else {
          this.getBookingTracking();
        }

        this.cdr.detectChanges();
        this.refreshMobileSheetAfterRealtimeUpdate();
      });
    },
  });
}

  private refreshMobileSheetAfterRealtimeUpdate(): void {
    if (!this.isMobileViewport) return;

    setTimeout(() => {
        this.measureSheet();
        this.cdr.detectChanges();
    }, 0);
  }

  getBookingDetail(): void {
    this._spinnerService.addToLoader('getookingDetail');

    // (this.platformServiceType === PANEL_SERVICE_TYPE.RIDE_HAILING
       this._bookingService.getRideBookingById(this.bookingId ? this.bookingId : '')
      // : this._bookingService.getBookingById(this.bookingId ? this.bookingId : '')
    .pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this._zone.run(() => {
          this._spinnerService.removeFromLoader('getookingDetail');
          this.bookingDetail = res;
          this.applyDurationPayload(res);
          this.syncArrivalTimer();
          this.syncTrackingUi();

          if (this.bookingDetail) {
            const key = this.bookingDetail.corprateBookingType == 1 ? 'clientId' : 'employeeId';
            const userDetais = this.bookingDetail ? this.bookingDetail[key] : [];

            if (userDetais && userDetais.length) this.bookingDetail['bookingUser'] = userDetais[0];
          }
          this._initialService.load()
            .then(() => {
                this.initializeMapAndRoute();
                this.handleListenerforLatLng();
                this.handleEmitterForLatLng();
                this._trackingLogicService.handleRealTimeUpdationForLatAndLng(this);
                this.driverAssignedToUserBooking();
            })
            .catch((err) => console.error('Failed to load Google Maps SDK', err));
        });
      },
      error: () => {
          this.bookingDetail = null;
          this._spinnerService.removeFromLoader('getookingDetail');
      },
    });
  }

  driverAssignedToUserBooking(): void {
    if (this.driverAssignedListenerBound) return;
    this.driverAssignedListenerBound = true;

    this._socketService.onEvent('driverAssignedToUserBooking').pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this._zone.run(() => {
          console.log(res);

          if (this.bookingDetail) {
            this.bookingDetail['driverId'] = res.data.driverId;
            this.bookingDetail['stageTwoDriverId'] = res.data.stageTwoDriverId;
          }
        });
      },
    });
  }

  private syncTrackingUi(): void {
    this.updateTrackingEta();

    const status = this.bookingDetail?.orderStatus;
    const bd = this.bookingDetail as any;
    const dropOffTimerLive = this.isArrivedAtDropOffStatus(status) &&
      !!bd?.isDropOffInHotZone &&
      !this.hasDropOffWaitingEnded(bd);

    if (this.isArrivedAtPickupStatus(status) || this.isWaitingStatus(status) || dropOffTimerLive) {
      this.updateTrackingTimer();
      this.startTimerLoop();
    } else {
      this.stopTimerLoop();
      this.timerText = '';
      this.timerMode = null;
    }
  }

  private startTimerLoop(): void {
    if (this.timerIntervalId) return;

    this.updateTrackingTimer();
    this.timerIntervalId = setInterval(() => {
        this.updateTrackingTimer();
        if (this.hasDropOffWaitingEnded(this.bookingDetail as any)) {
          this.stopTimerLoop();
          this.timerText = '';
          this.timerMode = null;
        }
    }, 1000);
  }

  @HostListener('document:visibilitychange')
  protected onVisibilityChange(): void {
    if (typeof document === 'undefined' || document.visibilityState !== 'visible') return;
    this._zone.run(() => {
      this.measureSheet();

      this.syncArrivalTimer();
      this.syncTrackingUi();

      if (this.isMobileViewport) {
        this.resumeTrackingAfterInactivity();
      }
    });
  }

  resumeTrackingAfterInactivity(): void {
    if (!this.bookingId) return;

    // Re-establish the socket transport in case it was suspended while inactive.
    this._socketService.initSocket(this.bookingId);
    this.getBookingDetail();
  }

  // getBookingStatusByKey(key: number | null | undefined): string {
  //   if (this.platformServiceType === PANEL_SERVICE_TYPE.RIDE_HAILING) {
  //     return key != null && this.rhRideStatusLabel[key]
  //       ? this.rhRideStatusLabel[key]
  //       : '';
  //   }

  //   const statusKey = Object.keys(this.allBookingStatuses).find((status) => this.allBookingStatuses[status] === key);
  //   if (
  //     (key == this.allBookingStatuses.RENTAL_STAGE_ONE_DROP_OFF_COMPLETED && this.bookingDetail?.stageTwoDriverId) ||
  //     (key == this.allBookingStatuses.RENTAL_BOOKED && this.bookingDetail?.driverId)
  //   )
  //     return 'VALET_ASSIGNED';

  //   if (key == this.allBookingStatuses.CHAUFFER_BOOKED && this.bookingDetail?.driverId)
  //     return 'CHAUFFER_ASSIGNED';

  //   if (statusKey) {
  //     return statusKey;
  //   }
  //   return '';
  // }

  protected get isRideCompleted(): boolean {
    return this.bookingDetail?.orderStatus === RhRideStatus.RIDE_COMPLETED;
  }

  copyPhoneNo() {
    if (this.bookingDetail?.driverId) {
      navigator.clipboard
        .writeText(`${this.bookingDetail?.driverId?.dialCode}${this.bookingDetail?.driverId?.phoneNo}`,)
        .then(() => {
          this._toasterService.successToastr(this._translateService.instant('PhoneNoCopied'));
        })
        .catch((err) => console.error('Failed to copy!', err));
    }
  }

  private normalizeDurationPayload(payload: any): { distanceMeters: number; durationSeconds: number } | null {
    return (payload?.last_duration ?? payload?.trip_duration ?? payload?.distanceDetails ?? null);
  }

  private applyDurationPayload(payload: any): void {
    const duration = this.normalizeDurationPayload(payload);
    if (duration && this.bookingDetail) {
      (this.bookingDetail as any).last_duration = duration;
    }
  }

  protected get driverRatingLabel(): string | null {
    const driver = this.bookingDetail?.driverId as any;
    const rating = driver?.avgRating;
    if (rating === null || rating === undefined || rating === '') return null;
    const numeric = Number(rating);
    return Number.isFinite(numeric) && numeric > 0 ? numeric.toFixed(1) : null;
  }

  ngOnDestroy(): void {
    this.sheetResizeObserver?.disconnect();
    this.locationListenerBound = false;
    this.stopTimerLoop();
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}